import { string, arrayOf, object } from 'prop-types';

export const INSPIRATION = {
    title: string,
    variations: arrayOf(object),
};
